<template>
  <div class="parking-detail">
    <div class="detail-content">
      <div class="header-title">
        <h2>车牌号：{{detail.plateNumber}}（{{detail.name}}）</h2>
      </div>
      <div class="info" v-for="(item, index) in info" :key="index">
        <div class="info-title">
          <span class="icon"></span>
          <span class="info-title-text">{{item.title}}</span>
        </div>
        <ul>
          <el-row v-for="(rowItem, rowIndex) in item.infoRow" :key="rowIndex">
            <template v-for="(liItem,liIndex) in rowItem.li">
              <li class="info-item" v-if="liItem.showStatus.includes(detail.status)" :key="liIndex">
                <span class="label">{{liItem.label}}</span>
                <span :class="detail.status + ' value ' + liItem.key">
                  {{liItem.isTime ? (liItem.value ? $moment(liItem.value).format('YYYY/MM/DD HH:mm:ss') : '-') : (liItem.value)}}
                  {{liItem.value && ['preAmount', 'totalAmount'].includes(liItem.key) ? '元' : ''}}
                  {{liItem.value && ['duration'].includes(liItem.key) ? '分钟' : ''}}
                </span>
              </li>
            </template>
          </el-row>
        </ul>
      </div>
      <div class="discount-box">
        <div class="info-title">
          <span class="icon"></span>
          <span class="info-title-text">优惠信息</span>
        </div>
        <Table
          :tableThData="tableThData_discount"
          :tableTrData="tableTrData_discount"
          :loading="loading"
          :pagination="false"
        >
          <template #name="{ row }">{{ row.name }}</template>
          <template #discount="{ row }">{{ row.discount }}</template>
        </Table>
      </div>
      <div class="pay-box">
        <div class="info-title">
          <span class="icon"></span>
          <span class="info-title-text">订单记录</span>
        </div>
        <Table
          :tableThData="tableThData"
          :tableTrData="tableTrData"
          :loading="loading"
          :pagination="false"
        >
          <template #orderNo="{ row }">{{ row.orderNo }}</template>
          <template #payTime="{ row }">{{ row.payTime ? $moment(row.payTime).format('YYYY/MM/DD HH:mm:ss') : '' }}</template>
          <template #amount="{ row }">{{ row.amount }}</template>
          <template #actualAmount="{ row }">{{ row.actualAmount }}</template>
          <template #discounts="{ row }">
            <div v-if="row.discounts.length!=0">
              <div v-for="(item, index) in row.discounts" :key="index">{{ item.name }} {{ item.discount }}</div>
            </div>
            <div v-else>---</div>
          </template>
          <template #phone="{ row, scope }">
            <span :key="tableKey" v-if="row.phone">{{ row.phone_show || row.phone }}</span>
            <span v-else>---</span>
            <auth-button auth="user:phone:read">
              <el-button v-if="row.phone" class="look-phone-btn" type="text" @click="onLookPhone(row, scope.$index)">
                {{ row.phone_show ? '隐藏' : '查看' }}
              </el-button>
            </auth-button>
          </template>
        </Table>
      </div>
    </div>
    <div class="footer">
      <el-button type="default" @click="goback">返回</el-button>
    </div>
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import { api_getParkingRecord } from '@/api/parking'
import Table from "@/components/Table/index";
import tableList from '@/mixins/tableList';
import { api_getUserPhone } from '@/api/common'
import aes from '@/common/aes.js'
export default {
  name: "parkingDetail",
  mixins: [tableList],
  components: {
    Table,
    AuthButton
  },
  data() {
    return {
      userId: '',
      phone: '',
      showPhone: false,
      info: [{
        title: '基础信息',
        infoRow: [{
          li: [{
            label: '状态：',
            value: '',
            key: 'status',
            showStatus: ['计费中', '已出场']
          },{
            label: '入场时间：',
            value: '',
            key: 'enterTime',
            showStatus: ['计费中', '已出场'],
            isTime: true
          },{
            label: '出场时间：',
            value: '',
            key: 'exitTime',
            showStatus: ['计费中', '已出场'],
            isTime: true
          }]
        },{
          li: [{
            label: '停车时长：',
            value: '',
            key: 'duration',
            showStatus: ['计费中', '已出场']
          },{
            label: '订单金额：',
            value: '',
            key: 'totalAmount',
            showStatus: ['计费中', '已出场']
          },{
            label: '已付金额：',
            value: '',
            key: 'preAmount',
            showStatus: ['计费中', '已出场']
          }]
        }]
      }],
      tableThData: [
        { prop: "orderNo", label: "交易流水号", minWidth: "130", },
        { prop: "payTime", label: "缴费时间", minWidth: "180", },
        { prop: "amount", label: "应付金额（元）", minWidth: "150", },
        { prop: "actualAmount", label: "实付金额（元）", minWidth: "150", },
        { prop: "discounts", label: "优惠信息", minWidth: "200", },
        { prop: "phone", label: "缴费会员手机号", minWidth: "150", },
      ],
      tableKey: false,
      detail: {},
      tableThData_discount: [
        { prop: "name", label: "优惠名称", minWidth: "130", },
        { prop: "discount", label: "优惠金额", minWidth: "180", },
      ],
      tableTrData_discount: []
    };
  },
  created () {
    this.getParkingRecord()
  },
  methods: {
    async getParkingRecord () {
      const data = await api_getParkingRecord({id: this.$route.query.id})
      this.detail = data
      this.tableTrData = data.orders || []
      this.tableTrData_discount = data.thirdDiscounts || []
      this.info.forEach((item) => {
        item.infoRow.forEach((infoRowItem) => {
          infoRowItem.li.forEach((liItem) => {
            liItem.value = data[liItem.key]
            // if(liItem.key == 'duration'){
            //   liItem.value = data[liItem.key] ? data[liItem.key] + '分钟' : ''
            // }
          })
        })
      })
    },

    getList() {},

    goback () {
      this.$router.go(-1)
    },

    formatStatus (status) {
      switch (status) {
        case 'Billing':
          return '计费中'
        case 'Left':
          return '已出场'
      }
    },
    // 点击查看手机号
    async onLookPhone(row, index) {
      try {
        if (row.phone_show) {
          delete this.tableTrData[index].phone_show
        } else {
          const {phone} = await api_getUserPhone({id: row.userId})
          this.tableTrData[index].phone_show = aes.decrypt(phone)
        }
        this.tableKey = !this.tableKey
      } catch (error) {}
    },
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.parking-detail {
  padding: 0 20px;
  padding-bottom: 80px;
  // min-width: 1162px;
  // overflow-x: auto;

  .info-title{
    display: flex;
    align-items: center;
    .icon{
      width: 5px;
      height: 25px;
      background: #05C8AF;
      border-radius: 2px;
      display: inline-block;
    }
    .info-title-text{
      font-size: 18px;
      font-weight: 600;
      color: #333333;
      line-height: 28px;
      height: 25px;
      margin-left: 10px;
    }
  }
  .detail-content{
    .header-title{
      height: 84px;
      border-bottom: 1px solid #ccc;
      h2{
        line-height: 84px;
        font-size: 20px;
        font-weight: 600;
        color: #333333;
        margin: 0;
      }
    }
    .info{
      margin-top: 30px;
      padding-bottom: 30px;
      border-bottom: 1px solid #ccc;
      .status.Paying, .status.Billing{
        color: #F74A4A;
      }
      .el-divider {
        margin: 50px 0;
      }

      ul{
        margin: 0;
        padding: 0;
        .info-item{
          margin: 0;
          padding: 0;
          list-style: none;
          margin-top: 30px;
          font-size: 14px;
          color: #333;
          display: inline-block;
          .label{
            width: 100px;
            text-align: right;
            display: inline-block;
          }
          .value{
            width: 180px;
            display: inline-block;
            button{
              padding: 0;
              margin-left: 10px;
            }
            .look-phone{
              font-size: 12px;
              color: #1a5cf5;
              margin-left: 0;
            }
          }
        }
      }
    }
  }

  .discount-box {
    margin-top: 30px;
    // padding-bottom: 30px;
    // border-bottom: 1px solid #ccc;
  }

  .pay-box {
    margin-top: 30px;
  }

  .footer{
    position: fixed;
    bottom: 0;
    height: 80px;
    background: #fff;
    width: calc(100vw - #{$base-left-menu-width});
    left: $base-left-menu-width;
    padding-left: 70px;
    padding-top: 23px;
    box-sizing: border-box;
    bottom: 0;
    button{
      padding: 0;
      height: 34px;
      text-align: center;
      width: 110px;
      font-size: 16px;
      color: #666666;
      border: 0;
    }
  }
}
</style>
